<template>
  <div>
    <div>
       <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading :active.sync="isLoading" loader="spinner" color="#36304a" :width="70"></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <!-- <b-navbar
          class="formCard"
          style=" border-radius: 5px !important;padding-left:0px"
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-brand center>Transportation Reports</b-navbar-brand>
 
         
        </b-navbar> -->
        <md-tabs>
          <md-tab md-icon="home" md-label="Dashboard">
            <div class="row mb-3">
              <div class="col-md-11">
                <date-range-picker class="pull-right" :opens="openLeft" :always-show-calendars="showCal"
                  v-model="dateRange" :startDate="startDate" :endDate="endDate" :locale-data="locale"
                  @update="viewAssignment('0', '1', '1')">
                  <!--Optional scope for the input displaying the dates -->
                  <!-- <div slot="input" slot-scope="picker">{{ picker.startDate }} - {{ picker.endDate }}</div> -->
                </date-range-picker>
              </div>
              <div class="col-md-1">
                <b-button style="margin-right: 5px; margin-top: 4px" size="sm" class="pull-right ml-1"
                @click="viewAssignment('0', '1', '1','clear')" variant="outline-info">Clear</b-button>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-md-12 grid-margin">
                <div class="card">
                  <div class="card-body">
                    <h4 class="card-title mb-0">Top Container Types</h4>
                    <p class="mb-0 ml-1 text-muted">
                      By No. of Times Repaired
                    </p>
                    <div id="chart2">
                      <apexchart type="bar" v-if="showGraph == true" height="350" :options="chartOptionsRefuel"
                        :series="seriesRefuel"></apexchart>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <div class="col-md-6 grid-margin">
                <div class="card">
                  <div class="card-body">
                    <h4 class="card-title mb-0">Top Export Destination</h4>
                    <p class="mb-0 ml-1 text-muted">
                      By No. of Containers
                    </p>
                    <div id="chart2">
                      <apexchart type="bar" v-if="showGraph == true" height="350" :options="chartOptionsExDesti"
                        :series="seriesExDesti"></apexchart>
                    </div>
                  </div>
                </div>
              </div> -->
            </div>
               <div class="row mt-4">
            <div class="col-md-12 grid-margin">
                <div class="card">
                  
                  <div class="card-body">
                    <h4 class="card-title mb-0">Survey</h4>
                    <p class="mb-0 ml-1 text-muted">
                      By No. of Containers 
                    </p>
                  <div class="mt-2" >
                     <model-list-select
                     @input="viewAssignment('0', '1', '1')"
                     style="width:200px"
                    :list="monthsArry"
                    v-model="monthName"
                    option-value="mV"
                    option-text="mT"
                    placeholder="Select Month"
                  ></model-list-select>
                  </div>
                  <div id="chart1" v-if="showGraph == true">
        <apexchart type="bar" height="350" :options="chartOptionsSurvey" :series="seriesSurvey"></apexchart>
      </div>
                  </div>
                </div>
              </div> 
              
            </div>
            <div class="row mt-4">
            <div class="col-md-12 grid-margin">
                <div class="card">
                  
                  <div class="card-body">
                    <h4 class="card-title mb-0">Gate-In Gate-Out</h4>
                    <p class="mb-0 ml-1 text-muted">
                      By No. of Containers 
                    </p>
                  <div class="mt-2" >
                     <model-list-select
                     @input="viewAssignment('0', '1', '1')"
                     style="width:200px"
                    :list="monthsArry"
                    v-model="monthName"
                    option-value="mV"
                    option-text="mT"
                    placeholder="Select Month"
                  ></model-list-select>
                  </div>
                  <div id="chart" v-if="showGraph == true">
        <apexchart type="bar" height="350" :options="chartOptionsGate" :series="seriesGate"></apexchart>
      </div>
                  </div>
                </div>
              </div> 
              
            </div>
              <div class="mt-4">
              <div>
                <b-button variant="outline-dark" :class="visible ? null : 'collapsed'"
                  :aria-expanded="visible ? 'true' : 'false'" aria-controls="collapse-4" @click="visible = !visible">
                  Filters</b-button>

                <b-button class="pull-right" v-if="veiwVehicleBookingForm.length>0" @click="getReports" size="sm"
                  variant="warning">Export as Excel</b-button>

              </div>


              <b-collapse v-model="visible" id="collapse-2">
                <b-card class="gutr">
                  <md-layout md-gutter>
                <md-layout md-flex="20" md-flex-small="100">
                  <model-list-select
                    :list="transportTypeName"
                    v-model="transportTypeFilter"
                    option-value="transportTypeVal"
                    option-text="transportTypeText"
                    placeholder="Select Status"
                  ></model-list-select>
                </md-layout>
                
                    <md-layout md-flex="5"></md-layout>
                    <md-layout md-flex="20" md-flex-small="100">
                     <model-list-select
                    :list="typeList"
                    v-model="typeFilter"
                    option-value="tV"
                    option-text="tT"
                    placeholder="Select Type"
                  ></model-list-select>
                    </md-layout> 
                  </md-layout>

                  <div class="mt-3">
                    <b-button size="sm" :disabled="typeFilter=='' && transportTypeFilter==''?true:false" @click="filterSearch" variant="outline-primary">Search
                    </b-button>
                    <b-button style="margin-right:5px" size="sm"  @click="clearFilter"
                      variant="outline-info">clear</b-button>
                  </div>
                </b-card>
              </b-collapse>
            </div>

            <div>

              <h5 class="text-muted pull-right mt-2 ml-3">
                <small>{{totalRows}} Entries</small>
              </h5>
            </div>



            <div class="table-responsive tableMain gutr">
              <b-table show-empty stacked="md" :items="veiwVehicleBookingForm" :fields="fields" :per-page="perPage"
                :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection">
                <template slot="gateInId" slot-scope="row0">
                    <span>{{row0.index + 1 + (currentPage - 1) * perPage }}</span>
                  </template>
                  <template slot="containerNo" slot-scope="row1">
                    <span
                    
                    >{{(row1.item.containerNo=='' || row1.item.gateInType=='Empty_Vehicle')?" --- ":row1.item.containerNo}}</span>
                  </template>
                  <template slot="loginTime" slot-scope="row12">
                    <span>{{row12.item.loginTime }}</span>
                  </template>
                  <template slot="delaySurveyStatus" slot-scope="row123">
                    <div v-if="row123.item.delaySurveyStatus==1">
                      <span style="color:red">Not Completed In 24 Hours</span>
                      <br>
                    </div>
                    <div v-else-if="row123.item.delaySurveyStatus==0">
                      <span style="color:red">Survey Pending</span>
                    </div>
                    <div v-else>
                      <span style="color:green">Survey Done</span>
                    </div>
                  </template>
                 
                  <template slot="shippingApproval" slot-scope="row3">
                    <span
                      :style="row3.item.repairCompletedNot==null || row3.item.repairCompletedNot==''?{ 'color': 'red' }:{ 'color': 'green' }"
                    >{{row3.item.shippingApproval!='Approved'?" ---":row3.item.repairCompletedNot==null || row3.item.repairCompletedNot==''?"Pending":'Repair Done' }}</span>
                  </template>
                  <template slot="containerStatus" slot-scope="row32">
                    <span
                      :style="row32.item.containerStatus==1 || row32.item.repairCompletedNot=='Repair_Done'?{ 'color': 'green' }:{'color': 'red'}"
                    >{{row32.item.containerStatus==1?"Completed":row32.item.repairCompletedNot=="Repair_Done"?"Ready to Gate Out":"Pending"}}</span>
                  </template>

                
              </b-table>
            </div>
            <div>
              <b-pagination limit="25" align="center" v-model="currentPage" :per-page="perPage" :total-rows="totalRows"
                @change="onPageChange($event)"></b-pagination>
            </div>
          </md-tab>

          <!-- <md-tab md-icon="content_paste" md-label="Reports">
          
          </md-tab> -->


        </md-tabs>

      </b-card-text>
    </b-card>
  </div>
</template>


<script>
  import axios from "axios";
  import moment from "moment";
  import { ModelListSelect } from "vue-search-select";
// import Loading from "vue-loading-overlay";
  import CustomLoader from "../common/customLoader.vue";
  import DateRangePicker from "vue2-daterange-picker";
  import "vue-loading-overlay/dist/vue-loading.css";
  import DatePicker from "vue2-datepicker";
  import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat} from "../../helper/filters";
  import { globalPermissionStatus } from "../../helper/collection";

  export default {
    beforeMount() {
      if (globalPermissionStatus("Yard")) {
        this.$store.dispatch("setCurrentRoute", "/reports/yardReports");
      
        this.viewAssignment("0", "1", "1");

      } else {
        this.$router.push({
          path: "/dashboard"
        });
      }
    },
    data() {
      return {
        topcommodity: [],
        seriesExDesti: [
          {
            name: "No. of Containers",
            data: [],
          },
        ],
        chartOptionsExDesti: {
          chart: {
            height: 350,
            type: "bar",
          },
          plotOptions: {
            bar: {
              columnWidth: "50%",
              endingShape: "rounded",
            },
          },
          dataLabels: {
            enabled: true,
          },
          stroke: {
            width: 2,
          },

          grid: {
            row: {
              colors: ["#fff", "#f2f2f2"],
            },
          },
          xaxis: {
            labels: {
              rotate: -45,
            },
            categories: [],
            tickPlacement: "on",
          },
          yaxis: {
            title: {
              text: "No. of Containers",
            },
          },
          fill: {
            type: "",
            gradient: {
              shade: "dark",
              type: "horizontal",
              shadeIntensity: 1,
              gradientToColors: undefined,
              inverseColors: true,
              opacityFrom: 0.85,
              opacityTo: 0.85,
              stops: [50, 0, 100],
            },
          },
        },
       seriesGate: [{
            name: 'Gate-In',
            data: []
          }, 
         
          {
            name: 'Gate-Out',
            data: []
          }, 
          
          ],
          chartOptionsGate: {
            chart: {
              type: 'bar',
              height: 350
            },
            plotOptions: {
              bar: {
                horizontal: false,
                columnWidth: '55%',
                endingShape: 'rounded'
              },
            },
            dataLabels: {
              enabled: false
            },
            stroke: {
              show: true,
              width: 2,
              colors: ['transparent']
            },
            xaxis: {
              categories: [],
            },
            yaxis: {
              title: {
                text: 'Container'
              }
            },
            fill: {
              opacity: 1
            },
            tooltip: {
              y: {
                formatter: function (val) {
                  return  val + " Container"
                }
              }
            }
          },
            seriesSurvey: [ 
          {
            name: 'Survey',
            data: []
          }, 
          
          ],
          chartOptionsSurvey: {
            chart: {
              type: 'bar',
              height: 350
            },
            plotOptions: {
              bar: {
                horizontal: false,
                columnWidth: '55%',
                endingShape: 'rounded'
              },
            },
            dataLabels: {
              enabled: false
            },
            stroke: {
              show: true,
              width: 2,
              colors: ['transparent']
            },
            xaxis: {
              categories: [],
            },
            yaxis: {
              title: {
                text: 'Container'
              }
            },
            fill: {
              opacity: 1
            },
            tooltip: {
              y: {
                formatter: function (val) {
                  return  val + " Container"
                }
              }
            }
          },
        seriesRefuel: [
          {
            name: "No. of Containers  ",
            data: [],
          },
        ],
        chartOptionsRefuel: {
          chart: {
            height: 350,
            type: "bar",
          },
          plotOptions: {
            bar: {
              columnWidth: "50%",
              endingShape: "rounded",
            },
          },
          dataLabels: {
            enabled: true,
          },
          stroke: {
            width: 2,
          },

          grid: {
            row: {
              colors: ["#fff",  "#f8f8f2","#f2f2f2"],
            },
          },
          xaxis: {
            labels: {
              rotate: -45,
            },
            categories: [],
            tickPlacement: "on",
          },
          yaxis: {
            title: {
              text: "No. of Containers ",
            },
          },
          fill: {
            type: "gradient",
            gradient: {
              shade: "light",
              type: "horizontal",
              shadeIntensity: 0.25,
              gradientToColors: undefined,
              inverseColors: true,
              opacityFrom: 0.85,
              opacityTo: 0.85,
              stops: [50, 0, 100],
            },
          },
        },
        fieldsV: [
          {
            key: "vehicleTruckId",
            label: "Sr No.",
            sortable: true,
            sortDirection: "desc"
          },
          {
            key: "regdNo",
            label: "Vehicle No.",
            sortable: true,
            sortDirection: "desc"
          },

          {
            key: "noOfTripscount",
            label: " No. Of Trips",
            sortable: true,
            sortDirection: "desc"
          },



          {
            key: "sumDieselUsed",
            label: " Diesel Consumed (Ltr's)",
            sortable: true,
            sortDirection: "desc"
          }

        ],
        totalVehicleCount: "",
        availVehicleCount: "",
        bookVehicleCount: "",
        currentPageV: 1,
        perPageV: 10,
        totalRowsV: "",
        pageOptionsV: [5, 10, 15],
        sortByV: null,
        sortDescV: false,
        sortDirectionV: "desc",
        filterV: null,
        modalInfo: { title: "", content: "" },
        clientMaster: [],

        topTPTClientRevenue: [],
        vehicleReports: [],
        clientIdFilter: "",
        transportTypeFilter: "",
        transportTypeName: [
          {
            transportTypeVal: "0",
            transportTypeText: "Pending"
          },
          {
            transportTypeVal: "1",
            transportTypeText: "Completed"
          }
        ],
          typeFilter: "",
         typeList: [
          {
            tV: "0",
            tT: "Survey"
          },
          {
            tV: "1",
            tT: "Repair"
          },
           {
            tV: "2",
            tT: "Gate-Out"
          }
        ],
        reload: true,

        visible: false,
        startDate: "2017-09-05",
        endDate: "2017-09-15",
        openLeft: "left",
        showCal: false,
        dateRange: {},
        locale: {
          direction: "ltr",
          format: "mm/dd/yyyy",
          separator: " - ",
          applyLabel: "Apply",
          cancelLabel: "Cancel",
          weekLabel: "W",
          customRangeLabel: "Custom Range",
          daysOfWeek: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
          monthNames: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec"
          ],
          firstDay: 0
        },
        totalRows: "",
        currentPage: 1,
        perPage: 10,
        pageOptions: [20, 50, 100],
        sortBy: null,
        sortDesc: false,
        sortDirection: "asc",
        filter: null,
        docURL: URL_BASE_DOC,
        fields: [
        {
          key: "gateInId",
          label: "Sr No.",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "containerNo",
          label: "Container No.",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "loginTime",
          label: "Gate-In Date & Time",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "delaySurveyStatus",
          label: "Survey Status",
          sortable: true,
          sortDirection: "desc"
        },
        
        {
          key: "shippingApproval",
          label: "Repair Status",
          sortable: true,
          sortDirection: "desc"
        },

        {
          key: "containerStatus",
          label: "Gate-Out Status",
          sortable: true,
          sortDirection: "desc"
        },

         {
          key: "gateOutDateTime",
          label: "Gate-Out Date & Time",
          sortable: true,
          sortDirection: "desc"
        },

        
       

        ],
        NoOfAssignment: "",
        isLoading: false,
        showGraph: false,
        viewAssignment1: [],
        veiwVehicleBookingForm: [],
        monthName:"11",
      
      
        monthsArry: [
          {
mV:"1",
mT:"Jan"

          },
                    {
mV:"2",
mT:"Feb"

          },
                    {
mV:"3",
mT:"Mar"

          },
                    {
mV:"4",
mT:"Apr"

          },
                    {
mV:"5",
mT:"May"

          },
                    {
mV:"6",
mT:"Jun"

          },
                    {
mV:"7",
mT:"Jul"

          },
                    {
mV:"8",
mT:"Aug"

          },
                    {
mV:"9",
mT:"Sep"

          },
                    {
mV:"10",
mT:"Oct"

          },
                    {
mV:"11",
mT:"Nov"

          },
                    {
mV:"12",
mT:"Dec"

          },
        ],
      };
    },

    filters: {
      moment(date) {
        return DateFormat(date)
      }
    },

    mounted() {


      

     },
    beforeDestroy() { },
    destroyed() { },
    components: {
      ModelListSelect,
      // Loading,
      CustomLoader,
      DateRangePicker
    },
    computed: {
      sortOptions() {
        // Create an options list from our fields
        return this.fieldsV
          .filter(f => f.sortable)
          .map(f => {
            return { text: f.label, value: f.key };
          });
      },
       getMonth() {

          var d = new Date();
   return d.getMonth();
 
       
      },

    },

    methods: {
      onFilteredV(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.totalRowsV = filteredItems.length;
        this.currentPageV = 1;
      },
      filterSearch() {
        this.reload = false;
        this.viewAssignment("0", "1", "1");
      },
      clearFilter() {

        this.clientIdFilter = "";
        this.transportTypeFilter = "";
        this.typeFilter = "";
        this.dateRange = ""
        this.viewAssignment("0", "1", "1");
      },
      getReports() {

        let view_Assignment = {
          excelId: "Yard_Reports",
          dateRange: this.dateRange,
          typeFilter: this.typeFilter,
          transportTypeFilter: this.transportTypeFilter,

        };
        console.log(view_Assignment);
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Reports/reportsExcel_NewV3.php`,
          data: JSON.stringify(view_Assignment),
          crossDomain: true,

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId")
          }
        };

        axios(options)
          .then(result => {
            const { statusText, status, data } = result;
            if ( status == 200 && data) {


if(data.excelName!=undefined){ 

              window.location.href = `https://uploadsp.pridel.com/Pridel_Reports/` + data.excelName

}
              //       let abc= `${docURL}/Pridel_Reports/`+data.excelName

              // console.log(abc)



            }
          })
          .catch(error => { });


      },
      onPageChange: function (event) {
        let CURRENT = 0;
        if (event == "1") {
          CURRENT = 0;
        } else {
          CURRENT = event * this.perPage - this.perPage;
        }

        this.viewAssignment(CURRENT, "2", event);

        // let totalRows = 1064 / this.perPage;
        // if(this.totalRow )
      },
      viewVBookingPage(
        clientId,
        salesid,
        quotationId,
        assignId,
        vBookingId,
        followUpId
      ) {
        this.$sessionsStorage.set("clientId", clientId);
        this.$sessionsStorage.set("salesBookingId", salesid);
        this.$sessionsStorage.set("storeQuotationId", quotationId);
        this.$sessionsStorage.set("storeAssignId", assignId);
        this.$sessionsStorage.set("storeVehicleBookingId", vBookingId);
        if (followUpId == "" || followUpId == null) {
          this.$sessionsStorage.set("storefollowActivityId", "false");
        } else {
          this.$sessionsStorage.set("storefollowActivityId", followUpId);
        }

        this.$router.push({
          path: "/vehicle/vehicleBooking"
        });
      },
      goToTrack(AId) {
        this.$sessionsStorage.set("storeAssignId", AId);
        this.$sessionsStorage.set("backToDetailPage", "22");
        this.$router.push({
          path: "/vehicleQuotation/tranportMailDetails"
        });
      },
      goToMain() {
        this.$router.push({
          path: "/sales/salesBooking"
        });
      },
      doLoading() {
        this.isLoading = true;
      },
      doLoadingClose() {
        this.isLoading = true;

        setTimeout(() => {
          this.isLoading = false;
        }, 500);
      },

      JqueryFun() {
        return $(function () {
          return $("#viewVehicleBooking21212").DataTable();
        });
      },

      viewAssignmentpage(clientId, salesid, quotationId, assignId) {
        this.$sessionsStorage.set("storeAssignId", assignId);
        this.$sessionsStorage.set("clientId", clientId);
        this.$sessionsStorage.set("salesBookingId", salesid);
        this.$sessionsStorage.set("storeQuotationId", quotationId);
        this.$router.push({
          path: "/vehicle/vehicleBooking"
        });
      },

      viewAssignment(CURRENT, SEARCH, pageNumber, clear) {
        this.isLoading = true;
        this.showGraph = false;
        let dummyObj = ''
        if (clear == 'clear') {
          dummyObj = ""
        } else {
          dummyObj = this.dateRange
        }
        this.chartOptionsRefuel.xaxis.categories = [];
        this.seriesRefuel[0].data = [];
        this.veiwVehicleBookingForm = [];
        this.chartOptionsExDesti.xaxis.categories = [];
        this.seriesExDesti[0].data = [];
         this.chartOptionsGate.xaxis.categories = [];
         this.chartOptionsSurvey.xaxis.categories = [];
         this.seriesGate[0].data = [];
         this.seriesGate[1].data = [];
         this.seriesSurvey[0].data = [];
        
        this.topcommodity = []
        let view_Assignment = {
          searchVal: this.filter,
          fields: this.fields,
          fromSearch: SEARCH,
          currentPage: CURRENT,
          perPage: this.perPage,
          assignmentNo: "assignmentNo",
          dateRange: dummyObj,
          typeFilter: this.typeFilter,
          transportTypeFilter: this.transportTypeFilter,
          monthName: this.monthName 
        };
        console.log(view_Assignment);
       
       
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Reports/getYardReports.php`,
          data: JSON.stringify(view_Assignment),
          crossDomain: true,

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId")
          }
        };

        axios(options)
          .then(result => {
          
            const { statusText, status, data } = result;
            if ( status == 200 && data) {
              console.log(data)
              if (SEARCH != "2") {
                this.currentPage = 1;
                this.totalRows = data.totalData;
              } else {
                this.currentPage = pageNumber;
              }
              if (data.booking.length > 0) {
                this.veiwVehicleBookingForm = data.booking;
              }
              // if (data.topcommodity.length > 0) {
              //   this.topcommodity = data.topcommodity;
              // }
             
              if (data.topClientNameContainerExec.length > 0) {
                this.chartOptionsRefuel.xaxis.categories = data.topClientNameContainerExec
                this.seriesRefuel[0].data = data.topClientContainerExecCount
              }

              if (data.totalDays.length > 0) {
                this.chartOptionsGate.xaxis.categories = data.totalDays
                this.seriesGate[0].data = data.totalGateIn
                this.seriesGate[1].data = data.totalGateOut
              

 
              }
               if (data.totalDays.length > 0) {
                this.chartOptionsSurvey.xaxis.categories = data.totalDays
                this.seriesSurvey[0].data = data.totalSurveyCount
                
              

 
              }


              

   
           


  // this.monthName= new Date().getMonth() +1 
  //   console.log(this.monthName)  // this.monthsArry=moment.months()


              // if (data.topSlineName.length > 0) {

              //   this.chartOptionsShip.xaxis.categories = data.topSlineName
              //   this.seriesShip[0].data = data.topSlineContainerShipCount

              // }

              this.showGraph = true,
                this.isLoading = false;
            }
          })
          .catch(error => { });
      }
    }
  };
</script>
<style>
  .md-theme-default.md-tabs>.md-tabs-navigation {
  background-color: #ffffff;
}
.md-theme-default.md-tabs>.md-tabs-navigation .md-tab-header.md-active, .md-theme-default.md-tabs>.md-tabs-navigation .md-tab-header:focus {
  color: #625f6e;
}
.md-theme-default.md-tabs>.md-tabs-navigation .md-tab-header{
  color: #625f6e;
}
.md-theme-default.md-tabs > .md-tabs-navigation .md-tab-indicator {
  background-color: #002a48;
  height: 4px;
  border-radius: 10px;
}
.md-whiteframe {
  background: #fff;
  -webkit-box-shadow: 0 4px 24px 0 rgb(34 41 47 / 10%);
  box-shadow: 0 4px 24px 0 rgb(34 41 47 / 10%);
  border-radius: 0.423rem;
}
</style>


// WEBPACK FOOTER //
// yardReports.vue?218b8cef